




























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { LOCALES } from "@/i18n/locales";
import { i18n, loadLanguageAsync } from "@/plugins/i18n";

@Component({
  components: {},
})
export default class SwitchLanguageComponent extends Vue {
  defaultLanguage: string = "en-US";
  langs: any = [];
  flag: any = true;

  mounted() {
    this.$services.languageManager.getLanguages().then((data: any) => {
      this.langs = data || [];
    });
  }
  
  onLanguageChange(value) {    
    // Sets language
    localStorage.setItem("ddlChanged", this.flag);
    loadLanguageAsync(value);
    let language = value.substr(0, value.indexOf("-"));
    this.$vuetify.lang.current = language;
    localStorage.setItem("language", value);

    window.location.reload();
  }
}
